module.exports = __webpack_public_path__ + "static/img/14010008.1c386762.png";